// Registre unique des langues d'INTERFACE (distinct des langues de CONTENU dans constants/languages.ts)
// Ajouter une langue future = 1 entrée ici + 1 dossier src/locales/xx/ + 1 entrée dans src/i18n/config.ts

export type InterfaceLanguageCode = 'fr' | 'en';

export interface InterfaceLanguageInfo {
  code: InterfaceLanguageCode;
  name: string;
  nativeName: string;
  flag: string;
}

export const INTERFACE_LANGUAGES: Record<InterfaceLanguageCode, InterfaceLanguageInfo> = {
  fr: { code: 'fr', name: 'Français', nativeName: 'Français', flag: '🇫🇷' },
  en: { code: 'en', name: 'Anglais', nativeName: 'English', flag: '🇬🇧' },
};

export const AVAILABLE_INTERFACE_LANGUAGES = Object.keys(INTERFACE_LANGUAGES) as InterfaceLanguageCode[];
export const DEFAULT_INTERFACE_LANGUAGE: InterfaceLanguageCode = 'fr';

export const isInterfaceLanguageAvailable = (code: string): code is InterfaceLanguageCode =>
  code in INTERFACE_LANGUAGES;

export const detectBrowserInterfaceLanguage = (): InterfaceLanguageCode => {
  try {
    const navLang = navigator.language?.slice(0, 2).toLowerCase();
    if (navLang && isInterfaceLanguageAvailable(navLang)) {
      return navLang as InterfaceLanguageCode;
    }
  } catch (error) {}
  return DEFAULT_INTERFACE_LANGUAGE;
};

export const getLastUsedInterfaceLanguage = (): InterfaceLanguageCode | null => {
  try {
    const last = localStorage.getItem('interfaceLanguage') as InterfaceLanguageCode;
    if (last && isInterfaceLanguageAvailable(last)) {
      return last;
    }
  } catch (error) {}
  return null;
};

export const saveInterfaceLanguage = (code: InterfaceLanguageCode): void => {
  try {
    localStorage.setItem('interfaceLanguage', code);
  } catch (error) {}
};
